import { render, staticRenderFns } from "./13.vue?vue&type=template&id=8634ce2a&scoped=true"
import script from "./13.vue?vue&type=script&lang=js"
export * from "./13.vue?vue&type=script&lang=js"
import style0 from "./13.vue?vue&type=style&index=0&id=8634ce2a&prod&lang=less&scoped=true"
import style1 from "./13.vue?vue&type=style&index=1&id=8634ce2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634ce2a",
  null
  
)

export default component.exports